"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeMap = exports.onPeriod = exports.isPeriodData = exports.hm2Num = exports.getRuleTypeList = exports.getRuleTypeByDate = exports.getInitState = exports.getDefaultPeriods = exports.getComputedRules = exports.currentFormat = exports.WEEKEND_RULE = exports.WEEKDAY_RULE = exports.NORMAL_RULE = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _excluded = ["type", "startPrice", "beyondDistanceFee", "distanceFee"];

var _typeMap;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var NORMAL_RULE = 1;
exports.NORMAL_RULE = NORMAL_RULE;
var WEEKDAY_RULE = 2;
exports.WEEKDAY_RULE = WEEKDAY_RULE;
var WEEKEND_RULE = 3;
exports.WEEKEND_RULE = WEEKEND_RULE;

var getRuleTypeByDate = function getRuleTypeByDate(ms) {
  var d = new Date(ms).getDay();
  return d === 0 || d === 6 ? 3 : 2;
};

exports.getRuleTypeByDate = getRuleTypeByDate;
var typeMap = (_typeMap = {}, (0, _defineProperty2["default"])(_typeMap, NORMAL_RULE, '不区分常规休息日'), (0, _defineProperty2["default"])(_typeMap, WEEKDAY_RULE, '常规'), (0, _defineProperty2["default"])(_typeMap, WEEKEND_RULE, '休息日'), _typeMap);
exports.typeMap = typeMap;

var getRuleTypeList = function getRuleTypeList() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (rules.distanceFee || []).filter(function (d) {
    return d.type !== 1;
  }).map(function (d) {
    return {
      label: typeMap[d.type],
      value: d.type
    };
  });
};

exports.getRuleTypeList = getRuleTypeList;

var mapStartPrice = function mapStartPrice(data) {
  var _secondKeyWord = data.secondKeyWord,
      _data$thirdKeyWord = data.thirdKeyWord,
      thirdKeyWord = _data$thirdKeyWord === void 0 ? _secondKeyWord : _data$thirdKeyWord;

  var _split$map = (data.firstKeyWord || '').split(' 且 ').map(parseFloat),
      _split$map2 = (0, _slicedToArray2["default"])(_split$map, 2),
      _split$map2$ = _split$map2[0],
      firstKeyWord = _split$map2$ === void 0 ? '' : _split$map2$,
      _split$map2$2 = _split$map2[1],
      secondKeyWord = _split$map2$2 === void 0 ? _secondKeyWord : _split$map2$2;

  return {
    distance: parseFloat(firstKeyWord),
    weight: parseFloat(secondKeyWord),
    configs: [{
      amount: thirdKeyWord,
      period: ''
    }]
  };
};

var mapOverMilesPrice = function mapOverMilesPrice(data) {
  return [{
    period: '',
    configs: data.map(function (d) {
      var firstKeyWord = d.firstKeyWord,
          secondKeyWord = d.secondKeyWord,
          thridKeyWord = d.thridKeyWord;
      return {
        distance: firstKeyWord,
        step: secondKeyWord,
        fee: thridKeyWord
      };
    })
  }];
};

var getComputedRules = function getComputedRules(rules, ruleType) {
  if (!rules) {
    return rules;
  }

  var _rules$type = rules.type,
      type = _rules$type === void 0 ? 1 : _rules$type,
      _startPrice = rules.startPrice,
      beyondDistanceFee = rules.beyondDistanceFee,
      _rules$distanceFee = rules.distanceFee,
      distanceFee = _rules$distanceFee === void 0 ? [] : _rules$distanceFee,
      others = (0, _objectWithoutProperties2["default"])(rules, _excluded);

  var _ref = distanceFee.find(function (d) {
    return d.type === ruleType;
  }) || {},
      _ref$startPrice = _ref.startPrice,
      startPrice = _ref$startPrice === void 0 ? mapStartPrice(_startPrice) : _ref$startPrice,
      _ref$overMilesPrice = _ref.overMilesPrice,
      overMilesPrice = _ref$overMilesPrice === void 0 ? mapOverMilesPrice(beyondDistanceFee) : _ref$overMilesPrice;

  return _objectSpread(_objectSpread({}, others), {}, {
    type: type,
    startPrice: startPrice,
    overMilesPrice: overMilesPrice
  });
};

exports.getComputedRules = getComputedRules;

var makeRange = function makeRange(length, of) {
  return (0, _toConsumableArray2["default"])(new Array(length)).map(function () {
    return of;
  }).join('');
};

var _padEnd = function _padEnd(a, b) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return (a + makeRange(b, c)).slice(0, Math.max(a.length, b));
};

var hm2Num = function hm2Num(hm) {
  return +_padEnd(hm.split(/\D/).join(''), 6);
};

exports.hm2Num = hm2Num;

var onPeriod = function onPeriod(period, hm) {
  var _period$split$map = period.split('-').map(hm2Num),
      _period$split$map2 = (0, _slicedToArray2["default"])(_period$split$map, 2),
      a = _period$split$map2[0],
      b = _period$split$map2[1];

  return hm >= a && hm < b;
};

exports.onPeriod = onPeriod;

var _padStart = function _padStart(a) {
  return "0".concat(a).slice(-2);
};

var getHM = function getHM(ms) {
  var d = new Date(ms);
  return +[d.getHours(), d.getMinutes(), d.getMinutes()].map(_padStart).join('');
};

var getPeriod = function getPeriod(configs, currentTime, ruleType) {
  if (configs) {
    var hm = getHM(currentTime);
    var matchRule = ruleType === NORMAL_RULE || getRuleTypeByDate(currentTime) === ruleType;

    var _ref2 = matchRule && configs.find(function (c) {
      return onPeriod(c.period, hm);
    }) || configs[0],
        period = _ref2.period;

    return period;
  }

  return '';
};

var getDefaultPeriods = function getDefaultPeriods(rules, ruleType) {
  if (!(rules && ruleType)) {
    return {};
  }

  var startPrice = rules.startPrice,
      overMilesPrice = rules.overMilesPrice,
      currentTime = rules.currentTime;
  return {
    startPricePeriod: getPeriod(startPrice.configs, currentTime, ruleType),
    overMilesPeriod: getPeriod(overMilesPrice, currentTime, ruleType)
  };
};

exports.getDefaultPeriods = getDefaultPeriods;

var getInitState = function getInitState(data) {
  if (!data) {
    return {
      ruleType: 1
    };
  }

  var ruleTypeList = getRuleTypeList(data);

  var _ruleTypeList = (0, _slicedToArray2["default"])(ruleTypeList, 1),
      _ruleTypeList$ = _ruleTypeList[0];

  _ruleTypeList$ = _ruleTypeList$ === void 0 ? {} : _ruleTypeList$;
  var ruleType = _ruleTypeList$.value;

  if (!ruleType) {
    ruleType = NORMAL_RULE;
  } else {
    ruleType = getRuleTypeByDate(data.currentTime);
  }

  return {
    ruleTypeList: ruleTypeList,
    ruleType: ruleType
  };
};

exports.getInitState = getInitState;

var currentFormat = function currentFormat(n) {
  return +(n / 100).toFixed(2);
};

exports.currentFormat = currentFormat;

var judge = function judge(o) {
  return !!o.period && o.period !== '普通时段';
};

var isPeriodData = function isPeriodData(data) {
  return data.some(function (d) {
    return judge(d) || d.configs.some(judge);
  });
};

exports.isPeriodData = isPeriodData;